module.exports = "/_next/static/images/delivery_1-c455ac441c753bffbcf64643e4466906.png";